import React, { useState } from "react";
import { useResetPassword } from "../../../api/useResetPassword";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Box,
} from "@mui/material";

import { useQueryClient } from "@tanstack/react-query";
const UserPasswordDialog = ({ isModalOpen, closeModal, data }) => {
  const [password, setPassword] = useState("");
  const resetPassword = useResetPassword();
  const queryClient = useQueryClient();

  const handlePasswordReset = () => {
    resetPassword.mutate(
      {
        email: data.email,
        password: password,
      },
      {
        onSuccess: () => {
          closeModal(); // 성공 시 모달 닫기
          queryClient.invalidateQueries("users");
          // 추가적인 성공 처리 로직 (예: 알림 표시)
        },
        // 에러 처리 로직 필요 시 구현
      }
    );
  };
  return (
    <Dialog open={isModalOpen} onClose={closeModal}>
      <DialogTitle>비밀번호 재설정</DialogTitle>
      <DialogContent>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            margin="dense"
            id="password"
            label="새 비밀번호"
            type="password"
            fullWidth
            variant="outlined"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeModal}>취소</Button>
        <Button onClick={handlePasswordReset}>수정</Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserPasswordDialog;
